import {forwardRef, useState} from "react";
import {getImagePathWithThemeSvg} from "../../utils";

const PlaceHolderImage = forwardRef((props:{url},ref)=>{
    const [isLoaded,setIsLoaded] = useState(false);
    return <>
        {
            !isLoaded &&
            <img className={'img-16'}
                 src={getImagePathWithThemeSvg('default_web_icon')}/>
        }
        <img className={'img-16'}
             style={{display:isLoaded?'':'none'}}
             src={props.url}
             onLoad={(e) => {
                 setIsLoaded(true);
             }}/>
    </>
})

export default PlaceHolderImage;